import ApiModule from './index'
import BaseModel from '../../base/BaseModel'
import { Alert, Toast } from '@src/components'

export class GetVipRoomInfoDetailById extends BaseModel {
	constructor(props = {}) {
		super(props)

		this.apiModule = ApiModule.SHOPPING
		this.url = '/product/getVipRoomInfoDetailById'
		this.desc = '根据产品id获取贵宾休息室详情'
	}
}

export class GetBatteryCarDetailById extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.SHOPPING
		this.url = '/product/getBatteryCarDetailById'
		this.desc = '根据产品id获取电瓶车详情'
	}
}

export class GetBookingVipRoomDetail extends BaseModel {
	constructor(props = {}) {
		super(props)

		this.apiModule = ApiModule.SHOPPING
		this.url = '/product/getBookingVipRoomDetail'
		this.desc = '根据产品id获取预订贵宾休息室服务详情'
	}
}

export class GetQueueServiceDetailDetailById extends BaseModel {
	constructor(props = {}) {
		super(props)

		this.apiModule = ApiModule.SHOPPING
		this.url = '/product/getQueueServiceDetailDetailById'
		this.desc = '根据产品id获取一条龙服务详情'
	}
}

export class GetBookingQueueServiceDetail extends BaseModel {
	constructor(props = {}) {
		super(props)

		this.apiModule = ApiModule.SHOPPING
		this.url = '/product/getBookingQueueServiceDetail'
		this.desc = '根据产品id获取预订一条龙服务详情'
	}
}

export class GetStopWayDetailById extends BaseModel {
	constructor(props = {}) {
		super(props)

		this.apiModule = ApiModule.SHOPPING
		this.url = '/product/getStopWayDetailById'
		this.desc = '根据产品id获取停车道服务详情'
		// test6677 102
		// this.setHeader({ channelSource: '102' })
	}
}

export class GetBookingStopWayDetailById extends BaseModel {
	constructor(props = {}) {
		super(props)

		this.apiModule = ApiModule.SHOPPING
		this.url = '/product/getBookingStopWayDetailById'
		this.desc = '根据产品id获取预订停车道服务详情'
	}
}

export class GetProductPackageDetails extends BaseModel {
	constructor(props = {}) {
		super(props)

		this.apiModule = ApiModule.SHOPPING
		this.url = '/product/getProductPackageDetails'
		this.desc = '获取权益包产品信息详情'
	}
}

export class GetEquityResourceDetails extends BaseModel {
	constructor(props = {}) {
		super(props)

		this.apiModule = ApiModule.SHOPPING
		this.url = '/product/getEquityResourceDetails'
		this.desc = '获取权益资源明细'
	}
}

export class GetDefaultOutboundProductDetails extends BaseModel {
	constructor(props = {}) {
		super(props)

		this.apiModule = ApiModule.SHOPPING
		this.url = '/product/getDefaultOutboundProductDetails'
		this.desc = '获取默认出入境服务产品信息详情'
	}
}

export class GetTravelBaoCityService extends BaseModel {
	constructor(props = {}) {
		super(props)

		this.apiModule = ApiModule.SHOPPING
		this.url = '/product/getTravelBaoCityService'
		this.desc = '获取当前城市出入境产品服务-出国宝服务-按国家分组'
	}
}

export class GetBookingOutboundDetailByTravelBaoItemId extends BaseModel {
	constructor(props = {}) {
		super(props)

		this.apiModule = ApiModule.SHOPPING
		this.url = '/product/getBookingOutboundDetailByTravelBaoItemId'
		this.desc = '根据出国宝服务套餐ID，确定预定产品的详情'
	}
}

export class GetOutboundResourceTravelOptions extends BaseModel {
	constructor(props = {}) {
		super(props)

		this.apiModule = ApiModule.SHOPPING
		this.url = '/product/getOutboundResourceTravelOptions'
		this.desc = '获取出入境产品-出国宝支持国家所有行程项'
	}
}

export class GetOutboundResourceVisaOptions extends BaseModel {
	constructor(props = {}) {
		super(props)

		this.apiModule = ApiModule.SHOPPING
		this.url = '/product/getOutboundResourceVisaOptions'
		this.desc = '获取出入境产品-出国宝支持国家是否需要签证项'
	}
}

export class QueryParingFee extends BaseModel {
	constructor(props = {}) {
		super(props)

		this.apiModule = ApiModule.SHOPPING
		this.url = '/ShangHaiAirportService/queryParingFee'
		this.desc = '停车费用查询接口'
	}

	dataformat(data) {
		// if (+data.resultCode) {
		//     Toast(data.errMsg)
		// }

		return data
	}
}

export class QueryParkingFeeV2 extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.WIRELESS
		this.url = '/pvgParkingFee/queryPvgParkingFee'
		this.desc = '停车费用查询接口V2'
	}

	dataformat(json) {
		return json
	}
}

export class QueryParkingException extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.SHOPPING
		this.url = '/ShangHaiAirportService/queryParkingException'
		this.desc = '停车缴费异常状况通知'
	}
	// dataformat(data) {
	//     return data
	// }
}

export class QueryParkingPayResult extends BaseModel {
	constructor(props = {}) {
		super()

		this.apiModule = ApiModule.SHOPPING
		this.url = '/ShangHaiAirportService/queryParkingPayResult'
		this.desc = '查询停车费支付结果，code 0 支付成功，其他失败'
	}

	dataformat(data) {
		return data
	}
}

export class CivilPeopleDetail extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.SHOPPING
		this.url = '/member/civilPeopleDetail'
		this.desc = '民航人详情'
	}
}

export class CivilPeopleRightsDetail extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.SHOPPING
		this.url = '/equity/detail'
		this.desc = '权益详情'
	}
}

export class GetFastSecurityCheckDetailById extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.SHOPPING
		this.url = '/product/getFastSecurityCheckDetailById'
		this.desc = '根据产品id获取快速安检产品详情'
		// test 102
		// this.setHeader({ channelSource: '102' })
	}
}

export class GetMultiResourceDetailById extends BaseModel {
	constructor(props = {}) {
		super(props)

		this.apiModule = ApiModule.SHOPPING
		this.url = '/product/getMultiResourceDetailById'
		this.desc = '根据产品id获取通用产品详情'
	}
}

export class GetLongTimeParkingDetailById extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.SHOPPING
		this.url = '/product/getLongTimeParkingDetailById'
		this.desc = '根据产品id获取长时停车产品详情'
	}
}

export class QueryAirportParkingList extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.SHOPPING
		this.url = '/ShangHaiAirportService/queryAirportParkingList'
		this.desc = '查询停车场列表'
	}
}
